import { QueryClient } from '@tanstack/vue-query'
import { Ref, ref } from 'vue'
import VendorService from '@/services/VendorService'
import { Vendor } from '@/models/vendor'

export default function useGetAllVendors() {
  const queryClient = new QueryClient()
  const data: Ref<Vendor[]> = ref(null)
  const error = ref(null)
  const vendorService = new VendorService()
  
  queryClient.fetchQuery({
    queryKey: ['vendors'],
    queryFn: async () => {
      const data = await vendorService.all()
      
      // create a detail cache for each item
      data.forEach((item) => {
        queryClient.setQueryData(['vendor', item.id], item)
      })

      return data
    }
  }).then((response) => {
    data.value = response
  }).catch((err) => { 
    error.value = err
  })

  return { data, error }
}